// extracted by mini-css-extract-plugin
export var commonStyle = "projects-template-common-module--commonStyle--3iOPs";